// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BL0P4","index":"styles_index__3opMi"};